<template>
  <div class="user-container">
    <slot name="header"></slot>
    <div class="content">
      <!-- <section class="upload-container">
        <el-image
          class="avatar"
          :src="Avatar"
          v-if="Avatar"
          :preview-src-list="[Avatar]"
        />
        <div class="default-avatar" v-else />
        <span class="upload-tip">
          推荐尺寸：264px*400px，请上传医生证件照，以便于管理员审核
        </span>

        <button class="user-upload-btn">
          <span>上传</span>
          <Upload @change="avatarChange" />
        </button>
      </section> -->
      <section class="fill-container">
        <div class="input-container">
          <label for="userName">
            <pre class="label need">姓&nbsp;&nbsp;&nbsp;名:</pre>
          </label>
          <el-input
            id="userName"
            placeholder="请输入您的姓名"
            v-model="UserName"
          />
        </div>
        <div class="input-container">
          <label for="IDCardNo">
            <pre class="label need">身份证号:</pre>
          </label>
          <el-input
            id="IDCardNo"
            placeholder="请输入您的身份证号"
            v-model="IDCardNo"
          />
        </div>
        <div class="input-container">
          <label for="Phone">
            <pre class="label need">手&nbsp;机&nbsp;号:</pre>
          </label>
          <el-input
            id="Phone"
            placeholder="请输入您的手机号"
            v-model="Phone"
            :disabled="!hasRegister"
          />
        </div>
        <div class="input-container">
          <label for="Email">
            <pre class="label need">电子邮箱:</pre>
          </label>
          <el-input
            id="Email"
            placeholder="请输入您的电子邮箱"
            v-model="Email"
          />
        </div>
        <!-- <div class="input-container">
          <label for="ImageCode">
            <pre class="label need">图形验证:</pre>
          </label>
          <el-input id="ImageCode" placeholder="请输入图形验证码" />
        </div> -->
        <!-- <div class="input-container">
          <label for="MsgCode">
            <pre class="label need">短信验证:</pre>
          </label>
          <el-input
            id="MsgCode"
            placeholder="请输入短信验证码"
            v-model="MsgCode"
          />
          <button class="code-btn" @click="getCode">
            {{ msgCodeContent }}
          </button>
        </div> -->
        <template v-if="hasRegister">
          <div class="input-container">
            <label for="Password">
              <pre class="label need">登录密码:</pre>
            </label>
            <el-input
              id="Password"
              placeholder="请输入您的登录密码"
              v-model="Password"
              show-password
            />
          </div>
          <div class="input-container">
            <label for="PsdConfirm">
              <pre class="label need">确认密码:</pre>
            </label>
            <el-input
              id="PsdConfirm"
              placeholder="请再次输入您的登录密码"
              v-model="PsdConfirm"
              show-password
            />
          </div>
        </template>
        <template v-if="hasRegister">
          <div class="input-container">
            <label>
              <pre class="label need">省&nbsp;&nbsp;&nbsp;份:</pre>
            </label>
            <Select
              class="select-container"
              placeholder="请选择省份"
              v-model="Province"
              :list="ProvinceList"
              @change="changeProvince"
            />
          </div>
          <div class="input-container">
            <label>
              <pre class="label need">城&nbsp;&nbsp;&nbsp;市:</pre>
            </label>
            <Select
              class="select-container"
              placeholder="请选择城市"
              v-model="City"
              :disabled="!Province"
              :list="CityList"
              @change="changeCity"
            />
          </div>
        </template>

        <div class="input-container">
          <label for="Hospital">
            <pre class="label need">所属医院:</pre>
          </label>
          <el-autocomplete
            class="input"
            v-model="Hospital"
            style="width: 210px"
            :fetch-suggestions="queryHospitalName"
            @select="selectHospitalName"
            :disabled="!City"
            placeholder="请输入所属医院，已有医院支持自动补全"
            clearable
          />
          
        </div>
        <!-- <div class="input-container">
          <label for="HospitalCode">
            <pre class="label need">医院代码:</pre>
          </label>
          <el-input
            type="text"
            id="HospitalCode"
            placeholder="请输入医院代码"
            v-model="HospitalCode"
          />
        </div>
        <div class="input-container">
          <label for="PersonalProfile">
            <pre class="label need">个人简介:</pre>
          </label>
          <div class="textarea">
            <el-input
              class="textarea"
              type="textarea"
              id="PersonalProfile"
              resize="none"
              :maxlength="limitLength"
              placeholder="例如：主任医师，教授，擅长专业：肺部小结节的鉴别诊断，肺癌 的个体化治疗。"
              v-model="PersonalProfile"
            />
            <span class="limit">
              <span class="tip">{{ PersonalProfile.length }}</span>
              /{{ limitLength }}
            </span>
          </div>
        </div> -->
        <div class="input-container">
          <label for="Department">
            <pre class="label need">所属科室:</pre>
          </label>
          <Select
            class="select-container"
            placeholder="请选择科室"
            v-model="Department"
            :list="DepartmentList"
          />
        </div>
        <!-- <div class="input-container">
          <label for="Skill">
            <pre class="label need">专业特长:</pre>
          </label>
          <Select
            class="select-container"
            placeholder="请选择专业特长"
            v-model="Skill"
            :list="SkillList"
          />
        </div> -->
        <div class="input-container">
          <label for="Title">
            <pre class="label need">职&nbsp;&nbsp;&nbsp;称:</pre>
          </label>
          <Select
            class="select-container"
            placeholder="请选择职称"
            v-model="Title"
            :list="TitleList"
          />
        </div>
        <div class="input-container">
          <label for="Title">
            <pre class="label need">类&nbsp;&nbsp;&nbsp;别:</pre>
          </label>
          <Select
            class="select-container"
            placeholder="请选择类别"
            v-model="Category"
            :list="CategoryList"
            @change="selectCategory"
          />
        </div>
        <div class="input-container">
          <label for="Title">
            <pre class="label need">行政职务:</pre>
          </label>
          <el-input
            id="job"
            placeholder="请输入行政职务"
            v-model="Job"
          />
        </div>

        <div class="input-container">
          <label for="Title">
            <pre class="label"><el-checkbox v-model="isAgree">自我申明</el-checkbox>:</pre>
          </label>
          <span style="font-size: 14px;color: #272222;">(本人保证所填写信息和提供材料均真实有效)</span>
        </div>
        <!-- <div class="input-container">
          <label for="Title">
            <pre class="label need">附&nbsp;&nbsp;&nbsp;件:</pre>
          </label>
          <div>
            <div class="image-container">
              <div
                class="image-item"
                v-for="(imageUrl, index) in AppendixList"
                :key="index"
              >
                <el-image
                  class="image"
                  :src="imageUrl"
                  :preview-src-list="[imageUrl]"
                />
                <span
                  class="delete-btn"
                  :data-index="index"
                  @click="deleteAppendix"
                ></span>
              </div>
              <button class="file-upload-btn">
                <Upload multiple @change="fileChange" />
              </button>
            </div>
            <span class="file-upload-tip" @click="getUserProfile">
              *可上传执业证、医师证、职称证，只支持上传图片
            </span>
          </div>
        </div> -->
        <slot name="footer" :user="userInfo"></slot>
      </section>
    </div>
  </div>
</template>
<script>
import Select from "@/components/Select";
// import Upload from "@/components/Upload";
import msgCodeMixin from "@/mixins/codeMixin";
import { fetchSendSms, fetchUCUserInfo } from "@/api/user";
import { fetchLocation } from "@/api/city";
import { fetchCompleteHospital } from "@/api/hospital";
import { checkParam } from "@/utils";
import { getToken } from "@/utils/auth";
export default {
  name: "Personal",
  data() {
    return {
      // 头像
      Avatar: "",
      // 姓名
      UserName: "",
      // 身份证号
      IDCardNo: "",
      // 手机号
      Phone: "",
      // 电子邮箱
      Email: "",
      // 短信验证
      MsgCode: "",
      // 登录密码
      Password: "",
      // 确定密码
      PsdConfirm: "",
      // 省份
      Province: "",
      // 省份列表
      ProvinceList: [],
      // 城市
      City: "",
      // 城市列表
      CityList: [],
      // 所属医院
      Hospital: "",
      // 医院代码
      HospitalCode: "",
      // 个人简介
      PersonalProfile: "",
      // 部门
      Department: "",
      // 部门列表
      DepartmentList: [
      {
          label:'呼吸与危重症医学科',
          value: '呼吸与危重症医学科',
        },
        {
          label:'呼吸科',
          value: '呼吸科',
        },
        {
          label:'影像科',
          value: '影像科',
        },
        {
          label:'病理科',
          value: '病理科',
        },
        {
          label:'其他',
          value: '其他',
        }
      ],
      // 技能
      Skill: "",
      // 技能列表
      SkillList: [],
      // 职称
      Title: "",
      // 职称列表
      TitleList: [
      {
          label:'主任医师',
          value: '主任医师',
        },
        {
          label:'副主任医师',
          value: '副主任医师',
        },
        {
          label:'医师',
          value: '医师',
        }
      ],
      // 类别列表
      // 临床医师、临床护师、医学及相关科研工作者)
      Category: '',
      CategoryList: [
        {
          label:'临床医师',
          value: '临床医师',
        },
        {
          label:'临床护师',
          value: '临床护师',
        },
        {
          label:'医学及相关科研工作者',
          value: '医学及相关科研工作者',
        }
      ],
      Job: "",
      // 附件
      AppendixList: [],
      // 字数限制
      limitLength: 50,
      isAgree: false,
      selectHospitalInfo:{}
    };
  },
  mixins: [msgCodeMixin],
  components: {
    // Upload,
    Select,
  },
  props: {
    action: {
      type: String,
      default: "add",
    },
  },
  computed: {
    userInfo() {
      return {
        // avatar: this.Avatar,
        userName: this.UserName,
        IDCardNo: this.IDCardNo,
        phone: this.Phone,
        email: this.Email,
        // msgCode: this.MsgCode,
        password: this.Password,
        psdConfirm: this.PsdConfirm,
        hospital: this.Hospital,
        department: this.Department,
        position: this.Job,
        // hospitalCode: this.HospitalCode,
        // personalProfile: this.PersonalProfile,
        // skill: this.Skill,
        career_name: this.Title,
        category: this.Category
        // appendix: this.AppendixList,
      };
    },
    hasRegister() {
      return this.action === "register";
    },
    msgCodeContent() {
      const { timeCount } = this;

      return timeCount == 0 ? "获取验证码" : `重新获取(${timeCount})`;
    },
  },
  mounted() {
    if (!this.hasRegister) {
      this.getUserProfile();
    } else {
      this.getProvinceList();
    }
  },
  methods: {
    async getUserProfile() {
      const { code, msg, data } = await fetchUCUserInfo({
        common_token: getToken(),
      });

      console.log(data,'getUserProfile');
      if (code == 0) {
        // this.Avatar = data.avatar;
        this.UserName = data.name;
        this.IDCardNo = data.id_card;
        this.Email = data.email;
        this.Phone = data.phone;
        this.Hospital = data?.hospital_name;
        this.Department = data?.department_name;
        this.Job = data?.position;
        this.Title = data?.career_name;
        this.Category = data?.category;
        this.selectHospitalInfo = {
          value: data?.hospital_name
        }

      } else {
        this.$message({ message: msg });
      }

      console.log("code", code, msg, data);
    },
    getCode() {
      this.clickCodeBtn();
    },
    getProvinceList() {
      fetchLocation({
        parent_code: "0",
      }).then((res) => {
        const { code, data } = res;
        if (code === 0) {
          this.ProvinceList = data.reduce((list, el) => {
            list.push({
              label: el.name,
              value: el.code,
            });
            return list;
          }, []);
        }
      });
    },
    getCityList() {
      fetchLocation({
        parent_code: this.Province,
      }).then((res) => {
        const { code, data } = res;
        if (code === 0) {
          this.CityList = data.reduce((list, el) => {
            list.push({
              label: el.name,
              value: el.code,
            });
            return list;
          }, []);
        }
      });
    },
    changeProvince() {
      this.CityList = [];
      this.City = "";
      this.Hospital = "";
      this.getCityList();
    },
    changeCity() {
      this.Hospital = "";
    },
    queryHospitalName(queryString, cb) {
      console.log(queryString, "queryString");

      fetchCompleteHospital({
        city_code: this.City,
        hospital: queryString,
      }).then((res) => {
        const { code, data } = res;
        if (code === 0) {
          if (data && data.length) {
            const hospitalList = data.reduce((list, el) => {
              list.push({
                value: el.name,
                ...el,
              });
              return list;
            }, []);
            cb(hospitalList);
          } else {
            cb([]);
          }
        }
      });
    },
    selectHospitalName(item) {
      console.log(this.Province,this.City,item,'selectHospitalName');
      
      this.selectHospitalInfo = item
      this.Hospital = item.value;
      this.$message({
        showClose: true,
        message: '请正确填写医院的完整名称，以确保您的课程学习数据可准确记录到医院规建评审中'
      });
    },
    selectCategory(){
      this.$message({
        showClose: true,
        message: '请正确填写医院的完整名称，以确保您的课程学习数据可准确记录到医院规建评审中'
      });
    },
    fetchSmsApi() {
      fetchSendSms({
        phone: this.Phone,
      });
    },
    avatarChange(imageList) {
      this.Avatar = imageList[0];
    },
    fileChange(imageList) {
      this.AppendixList = [...this.AppendixList, ...imageList];
    },
    deleteAppendix(ev) {
      const { index } = ev.target.dataset;
      this.AppendixList.splice(index, 1);
    },
    checkSms() {
      const phone = this.Phone.trim();
      const { status, message } = checkParam("phone").execute(phone);

      if (!status) {
        this.$message({ message, type: "error" });
      }

      return status;
    },
    checkSubmitParams(user) {
      
      let simpleParams = {
        // avatar: "请上传您的证件照",
        userName: "请输入您的姓名",
        // msgCode: "请输入您的短信验证码",
        hospital: "请选择所属省市及医院",
        department: "请输入所属科室",
      };
      let strictParams = {
        IDCardNo: "",
        phone: "",
        email: "",
      };

      // 补充字段
      let otherParams = {
        career_name: "请选择职称",
        category: "请选择类别",
        position: "请输入行政职务",
      };

      if (this.hasRegister) {
        Object.assign(simpleParams, {
          password: "请输入您的登录密码",
          psdConfirm: "请再次输入您的登录密码",
        });
      }

      for (let [key, value] of Object.entries(simpleParams)) {
        if (!user[key]) {
          this.$message({ message: value, type: "error" });
          return;
        }

        if (key === "password") {
          if (user.password.length < 6) {
            this.$message({
              message: "密码长度不能低于6位，请补全",
              type: "error",
            });
            return;
          }
          if (user.password !== user.psdConfirm) {
            this.$message({
              message: "密码与确认密码不一致，请重新输入",
              type: "error",
            });
            return;
          }
        }
      }

      for (let key of Object.keys(strictParams)) {
        const validParam = {
          phone: "phone",
          email: "mail",
          IDCardNo: "IDCard",
        };
        const param = validParam[key];
        const value = user[key].trim();
        const { status, message } = checkParam(param).execute(value);

        if (!status) {
          this.$message({ message, type: "error" });
          return;
        }
      }


      for (let [key, value] of Object.entries(otherParams)) {
        if (!user[key]) {
          this.$message({ message: value, type: "error" });
          return;
        }
      }
      console.log(this.selectHospitalInfo,user.hospital,'selectHospitalInfo');
      if(this.selectHospitalInfo.value != user.hospital){
        this.$message({ message: '请选择匹配的医院', type: "error" });
        return
      }

      if(!this.isAgree){
        this.$message({ message: '请勾选自我申明', type: "error" });
        return
      }

      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
